export { default, getServerSideProps } from '@/views/Homepage';
